import { useFeatureLoyaltyUiNoRewardQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

export const useFeaturesLoyaltyNoReward = () => {
  const { featureLoyaltyUIId = '', featureIdsLoading } = useFeaturesContext();
  const { data, loading } = useFeatureLoyaltyUiNoRewardQuery({
    variables: { featureLoyaltyUIId },
    skip: !featureLoyaltyUIId,
  });
  return {
    data: {
      noRewardPoints: data?.LoyaltyUI?.noRewardPoints,
      noRewardsAvailable: data?.LoyaltyUI?.noRewardsAvailable,
    },
    loading: featureIdsLoading || loading,
  };
};
